import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isHebrewPath, useLanguage } from "./LanguageContext";

/**
 * One-way sync from URL → language state.
 *
 * When the pathname enters the `/he/*` tree (via a Link click, browser
 * back/forward, or a Hebrew-search arrival), force language='he'. The
 * inverse direction is intentionally NOT mirrored: a Hebrew user who
 * lands on `/pricing` (via Google's English-language indexing of the
 * English prerender) should still keep their Hebrew preference from
 * the IP/timezone/localStorage detection in LanguageProvider — they're
 * the same user just on a different prerendered URL.
 *
 * Mounted inside <BrowserRouter> next to <Routes>; renders nothing.
 */
export function LanguageRouteSync(): null {
  const { pathname } = useLocation();
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    if (isHebrewPath(pathname) && language !== "he") {
      setLanguage("he");
    }
  }, [pathname, language, setLanguage]);

  return null;
}
